module.exports = __webpack_public_path__ + "img/introduceList2.95258f0e.jpg";